module.exports = __webpack_public_path__ + "static/img/img_member_a.18d8e542.png";